import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  components: {
    Text: {
      baseStyle: {
        //wordBreak: "break-all",
        //overflowWrap: "break-all",
        //whiteSpace: "normal",
        //wordBreak: "break-word", // Ensures long words break
        //overflowWrap: "break-word", // Helps with breaking inside words
        //whiteSpace: "normal", // Allows wrapping
        hyphens: "auto", // Adds hyphens for a more natural look
      },
    },
  },
});

export default theme;
